import type { CarDTO, LovCarDTO } from '@/features/api/extranet/dto/Demande/CAR'
import { EndPointsFormationDemandeCar } from '@/features/services'
import { buildDemandeService } from '../buildDemandeService'

export default buildDemandeService<'MODEL_CAR', LovCarDTO>({
  location: EndPointsFormationDemandeCar.location,
  normaliserData: normaliserData,
})

function normaliserData(data: CarDTO) {
  //data.typeDemande ??= TypeDemandeDossier
  data.fichiers ??= []

  data.employeur ??= {} as any
  data.employeur!.contact ??= {} as any
  data.employeur!.etablissement ??= {} as any
  data.employeur!.etablissement!.adresse ??= {} as any

  return data
}
